<script>
import useTenant from '@/shared/useTenant'
import useUser from '@/shared/useUser'

export default {
    props: {
        notificationsCount: {
            type: Number,
            default: 0
        }
    },
    emits: ['openNotificationTray'],
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    },
    computed: {
        showSystemLookup() {
            return useTenant().value.customer.IsOem && useUser().value.SysAdmin
        }
    },
    methods: {
        useUser,
        useTenant,
        showNotificationsTray() {
            this.$emit('openNotificationTray')
        }
    }
}
</script>

<template>
    <div class="flex space-x-2">
        <a
            v-if="showSystemLookup"
            href="/settings/system-lookup"
            class="flex justify-center items-center w-10 h-10 text-xl text-spotler-gray-600 hover:text-rss-blue-500 hover:bg-rss-light-blue-500 rounded-full focus:outline-none"
        >
            <i class="fa fa-search" />
        </a>
        <a
            href="/settings"
            class="flex justify-center items-center w-10 h-10 text-xl text-spotler-gray-600 hover:text-rss-blue-500 hover:bg-rss-light-blue-500 rounded-full focus:outline-none"
        >
            <i class="fa fa-cogs" />
        </a>
        <button
            class="relative w-10 h-10 text-xl text-spotler-gray-600 hover:text-rss-blue-500 hover:bg-rss-light-blue-500 rounded-full focus:outline-none"
            @click="showNotificationsTray"
        >
            <span
                v-if="notificationsCount > 0"
                class="absolute top-1 right-2 py-0 px-1 text-xs leading-3 text-white bg-rss-notifications-badge rounded-lg"
            >{{ notificationsCount }}</span>
            <i class=" fa fa-bell" />
        </button>
        <form
            id="logout-form"
            action="/logout"
            method="POST"
        >
            <input
                type="hidden"
                name="_token"
                :value="csrf"
            >
            <button
                type="submit"
                class="w-10 h-10 text-xl text-spotler-gray-600 hover:text-rss-blue-500 hover:bg-rss-light-blue-500 rounded-full focus:outline-none"
            >
                <i class="fa fa-sign-out-alt" />
            </button>
        </form>
    </div>
</template>
